import type { ReactNode } from "react";
import PageLayout from "./layout";

export default function (): ReactNode {
  return (
    <PageLayout title="NewsRPM Parser">
      <section>
        <h2>NewsRPM Parser</h2>
        <p>Please select a component to manage</p>
      </section>
    </PageLayout>
  );
}
